import React from "react"
import MUIListItemText from "@mui/material/ListItemText"

export type ListItemTextProps =
  | ({ new?: false } & React.ComponentProps<typeof MUIListItemText>)
  | ({ new: true } & unknown)

export const ListItemText = (props: ListItemTextProps) =>
  props.new ? null : <MUIListItemText {...props} />

export default ListItemText
